import { Autocomplete, FormControl, TextField } from "@mui/material";
import { sortBy } from "lodash";
import { useEffect } from "react";

interface AutocompleteFieldProps {
  fieldKey: string;
  value: string | null;
  onChange: (key: string, value: string | null) => void;
  options: { label: string; value: string; group?: string }[];
  label: string;
  disabled: boolean;
  required: boolean;
  selectFirstByDefault: boolean;
}

const AutocompleteField: React.FC<AutocompleteFieldProps> = ({
  fieldKey,
  value,
  onChange,
  options = [],
  label,
  disabled,
  required,
  selectFirstByDefault,
}) => {
  const selectedVal = options.find((x) => x.value === value) || null;

  const sortedOptions = sortBy(options, ["group", "label"]);

  useEffect(() => {
    if (value === undefined && selectFirstByDefault && options.length) {
      onChange(fieldKey, options[0].value);
    }
  });

  return (
    <FormControl required={required}>
      <Autocomplete
        groupBy={(option) => option.group ?? ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        disabled={disabled}
        filterOptions={(_options, params) =>
          _options.filter((_option) =>
            _option.label
              .toLowerCase()
              .includes(params.inputValue.toLowerCase()),
          )
        }
        value={
          selectedVal && {
            id: selectedVal.value,
            label: selectedVal.label,
            group: selectedVal?.group,
          }
        }
        options={sortedOptions.map((option) => ({
          label: option.label,
          id: option.value,
          group: option.group,
        }))}
        renderInput={(params) => (
          <TextField {...params} placeholder={label} required={required} />
        )}
        onChange={(_, item) => onChange(fieldKey, item ? item.id : null)}
      />
    </FormControl>
  );
};

export default AutocompleteField;
